import 'vue-loading-overlay/dist/vue-loading.css';
import './registerServiceWorker';
import '@/globals';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/free-brands-svg-icons/faApplePay';

import VueFormulate from '@braid/vue-formulate';
import Vue from 'vue';
import VueGtag from 'vue-gtag';
import VModal from 'vue-js-modal';
import Loading from 'vue-loading-overlay';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueScrollTo from 'vue-scrollto';
import Toasted from 'vue-toasted';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueLogger from 'vuejs-logger';

import App from './App.vue';
import router from './router';
import store from './store';

const isProduction = process.env.NODE_ENV === 'production';
Vue.config.productionTip = false;

Vue.use(VueFormulate, {
  uploader: async function(file, progress, error, options) {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const result = await fetch(options.uploadUrl, {
        method: 'POST',
        body: formData
      })
      progress(100);
      return await result.json()
    } catch (err) {
      error('Unable to upload file')
    }
  }
});
Vue.use(VModal, { dialog: true });

// https://www.npmjs.com/package/vuejs-logger#usage
const loggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: isProduction,
  showLogLevel: false,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};
Vue.use(VueLogger as any, loggerOptions);

// https://www.npmjs.com/package/vue-toasted#api
const toastedOptions = {
  className: 'toasty-toast',
  closeOnSwipe: true,
  containerClass: 'toasty-container',
  duration: 3750,
  fitToScreen: true,
  iconPack: 'fontawesome',
  keepOnHover: true,
  position: 'top-center',
  theme: 'bubble',
  action: {
    text: 'close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  },
};
Vue.use(Toasted, {
  router,
  ...toastedOptions
});
// https://vue-scrollto.netlify.app/
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease-in-out',
  offset: 0,
  force: false,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
// https://github.com/ankurk91/vue-loading-overlay/tree/v3.x
Vue.use(Loading, {
  color: 'rgb(145,0,9)',
  loader: 'bars',
});

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.26',
  },
});

Vue.use(VueGtag, {
  config: { id: 'GTM-TKMKJH' }
});

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY,
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
